import React from "react";
const MyPost = React.lazy(() => import('./myPost'));
const CreateKnowledge = React.lazy(() => import('../KnowledgeManagement/CreateKnowledge'));
export const myPostConfig = [
    {
        path: '/apps/mypost',
        element: <MyPost />
    },
    {
        path: '/apps/mypost/create',
        element: <CreateKnowledge />
    },
    {
        path: '/apps/mypost/create/:id',
        element: <CreateKnowledge />
    }
];

